export default "__VITE_ASSET__cae68c77__"